import {
  DynamicIppicaScommesseTableSecondaryInfo,
  IppicaScommesseTableSecondaryInfo,
} from '../ippicaScommesseTableSecondaryInfo/IppicaScommesseTableSecondaryInfo';
import React, { useState } from 'react';

import { IppicaScommesseTableInfoList } from '../ippicaScommesseTableInfoList';
import { IppicaScommesseTableMainInfo } from '../ippicaScommesseTableMainInfo';
import { IppicaScommesseTableMoreInfoButton } from '../ippicaScommesseTableMoreInfoButton';
import { IppicaScommesseTablePosition } from '../ippicaScommesseTablePosition';
import { breakpoint } from 'utility/constant';
import styles from './IppicaScommesseTableRowUiContainer.module.scss';
import useWindowSize, { enComparer } from 'hooks/useWindowSize';

export type IppicaScommesseTableRowUiContainerProps = {
  keyCavallo: string;
  providerID?: number;
  children: React.ReactNode;
};
export const IppicaScommesseTableRowUiContainer = ({
  keyCavallo,
  children,
  providerID,
}: IppicaScommesseTableRowUiContainerProps) => {
  const [isOpenMoreInfo, setIsOpenMoreInfo] = useState<boolean>(false);

  const { doCheck } = useWindowSize();
  const [isMobile] = doCheck([{ comparer: enComparer.less, size: breakpoint.lg }]);

  return (
    <div className={styles.container}>
      <IppicaScommesseTablePosition
        keyCavallo={keyCavallo}
        containerClassName={styles.position}
        isOpen={isOpenMoreInfo}
      />
      <IppicaScommesseTableMainInfo
        containerClassName={styles.mainInfo}
        keyCavallo={keyCavallo}
        isOpen={isOpenMoreInfo}
      />
      {!isMobile && (
        <DynamicIppicaScommesseTableSecondaryInfo
          containerClassName={styles.secondaryInfo}
          keyCavallo={keyCavallo}
          isOpen={isOpenMoreInfo}
        />
      )}
      <IppicaScommesseTableMoreInfoButton
        isOpen={isOpenMoreInfo}
        setIsOpen={setIsOpenMoreInfo}
        containerClassName={styles.moreBtn}
      />
      <div className={styles.quote}>{children}</div>
      <div className={`${styles.hideElement} ${isOpenMoreInfo ? styles.visible : ''}`}>
        {isMobile && (
          <IppicaScommesseTableSecondaryInfo
            containerClassName={styles.secondaryInfo}
            providerID={providerID}
            keyCavallo={keyCavallo}
            isOpen={isOpenMoreInfo}
          />
        )}
        <IppicaScommesseTableInfoList keyCavallo={keyCavallo} />
      </div>
    </div>
  );
};
